import { HostBinding } from "@angular/core";
import { AbstractControl } from "@angular/forms";

import { isInErrorState } from "./isInErrorState";
import { isRequired } from "./isRequired";

export abstract class SpsFormComponent {
    protected _control: AbstractControl;

    @HostBinding("class.sps-form-group--error")
    get isInErrorState() {
        return isInErrorState(this._control);
    }

    @HostBinding("class.sps-form-group--required")
    get isRequired() {
        return isRequired(this._control);
    }
}
